import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductRetirementAgesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductRetirementAgesReducer.productRetirementAgesFeatureKey]
);

export const getStaticDataProductRetirementAgesFailure = createSelector(
  getStaticDataProductRetirementAgesState,
  staticDataCountriesReducer.fromStaticDataProductRetirementAgesReducer.getProductRetirementAgesFailure
);

export const getStaticDataProductRetirementAgesResponse = createSelector(
  getStaticDataProductRetirementAgesState,
  staticDataCountriesReducer.fromStaticDataProductRetirementAgesReducer.getProductRetirementAgesResponse
);

export const getStaticDataProductRetirementAgesisLoaded = createSelector(
  getStaticDataProductRetirementAgesState,
  staticDataCountriesReducer.fromStaticDataProductRetirementAgesReducer.getProductRetirementAgesIsLoaded
);
